t = require('views/internal/teacup-with-helpers')('popover_set_email_freq')

module.exports = ->
  t.ul '.pop-over-list', { name: 'minutesBetweenSummaries' }, ->
    t.li ->
      t.a '.highlight-icon', { value: '-1' }, ->
        t.check t.mustacheVar('minutesBetweenSummaries_-1'), 'never'
        t.span '.sub-name', ->
          t.format 'don-t-send-emails'
    t.li ->
      t.a '.highlight-icon', { value: '60' }, ->
        t.check t.mustacheVar('minutesBetweenSummaries_60'), 'periodically'
        t.span '.sub-name', ->
          t.format 'send-emails-about-once-an-hour'
    t.li ->
      t.a '.highlight-icon', { value: '1' }, ->
        t.check t.mustacheVar('minutesBetweenSummaries_1'), 'instantly'
        t.span '.sub-name', ->
          t.format 'send-emails-as-soon-as-possible'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_set_email_freq.coffee